/** Ids das promoções/popups já visualizados (JSON array de números). */
const STORAGE_KEY_IDS = "associadas_banner_popup_seen_ids";

function readSeenIds(): number[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_IDS);
    if (!raw) return [];

    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];

    return parsed.filter(
      (x): x is number => typeof x === "number" && !Number.isNaN(x),
    );
  } catch {
    return [];
  }
}

export function hasSeenBannerPopup(id: number): boolean {
  try {
    return readSeenIds().includes(id);
  } catch {
    return false;
  }
}

export function markBannerPopupSeen(id: number): void {
  try {
    const ids = new Set(readSeenIds());
    if (ids.has(id)) return;

    ids.add(id);
    localStorage.setItem(
      STORAGE_KEY_IDS,
      JSON.stringify([...ids].sort((a, b) => a - b)),
    );
  } catch {
    /* storage indisponível */
  }
}

/** Zera promoções/popups já vistos (ex.: novo login). */
export function clearBannerPopupsSeen(): void {
  try {
    localStorage.removeItem(STORAGE_KEY_IDS);
  } catch {
    /* storage indisponível */
  }
}
